module.exports = __webpack_public_path__ + "static/media/projects.05bbf434.svg";